import { useCallback, useEffect, useState } from 'react'

import { ConnectorSerialPort } from '@/constants/medconnect-devices-types'
import { getSerialPorts } from '@/core/classes/MedconnectDevicesAPI'

export type SerialPortsState = {
  ports: ConnectorSerialPort[]
  isLoading: boolean
  refresh: () => void
}

/** Serial ports present on the computer running the connector. */
export function useSerialPorts(enabled: boolean): SerialPortsState {
  const [ports, setPorts] = useState<ConnectorSerialPort[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [generation, setGeneration] = useState(0)

  const refresh = useCallback(() => setGeneration((value) => value + 1), [])

  useEffect(() => {
    if (!enabled) return
    let cancelled = false
    setIsLoading(true)
    getSerialPorts()
      .then((result) => {
        if (!cancelled) setPorts(result)
      })
      .catch(() => {
        if (!cancelled) setPorts([])
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [enabled, generation])

  return { ports, isLoading, refresh }
}
